import { translationOrganizations_sv_part1 } from "./translationOrganizations.sv.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationOrganizations_sv_part2 } from "./translationOrganizations.sv.part2";
import { translationOrganizations_sv_part3 } from "./translationOrganizations.sv.part3";

export const translationOrganizations_sv = defineTranslationTree({
  ...translationOrganizations_sv_part1,
  ...translationOrganizations_sv_part2,
  ...translationOrganizations_sv_part3,
});
